import React, { useState, useEffect } from "react";

function CountdownWidget() {
    const [eventName, setEventName] = useState(undefined);
    const [eventDate, setEventDate] = useState(undefined);
    const [count, setCount] = useState(0);
    
    useEffect(() => {
        const eventName = localStorage.getItem('eventName');
        const eventDate = localStorage.getItem('eventDate');
        const count = localStorage.getItem('count');
        // parse string into JSON
        setEventName(JSON.parse(eventName));
        setEventDate(JSON.parse(eventDate));
        setCount(JSON.parse(count));

    // [] ensures that useEffect only runs once after reloading
    }, [] );
    function getCount(eventDate) {
        const userDate = eventDate.split("-");
        const then = new Date(userDate[0], userDate[1] - 1, userDate[2]);
        const today = new Date();
        // get number of days
        // set at midnight
        today.setHours(0);
        today.setMinutes(0);
        let count = Math.round((today - then) / (1000 * 60 * 60 * 24));
        
        if (then === 'Invalid Date') {
            alert("Invalid date, please use the correct format");
        } else if (count > 0) {
            alert("Invalid date, choose a date after today's date");
        } else {
            count = Math.abs(count);
            // set number of days
            setCount(count);
            localStorage.setItem('count', JSON.stringify(count));
        }
    };
    function clearEvent() {
        // reset all values
        setEventName("");
        setEventDate("");
        setCount(0);
        // remove from storage
        localStorage.removeItem('eventName');
        localStorage.removeItem('eventDate');
        localStorage.removeItem('count');
    }
    return (
            <div className="countdown-2 child-center">
                <h3 className="countdown-header">Countdown</h3>
                <div className="event">
                    <h3 className="count">{count}</h3>
                    <h4 className="days">{count !== 1 ? "Days" : "Day"}</h4>
                    <h4 className="until">Until {eventName}</h4>
                </div>

                <input className="event-name" name="eventName" placeholder="Event Name" 
                value={eventName}
                onChange = {event => {
                    setEventName(event.target.value);
                    localStorage.setItem('eventName', JSON.stringify(event.target.value));
                }}/>
                <input className="event-date" name="eventDate" placeholder="YYYY-MM-DD" 
                value={eventDate} 
                onChange={event => {
                    setEventDate(event.target.value);
                    localStorage.setItem('eventDate', JSON.stringify(event.target.value));
                    }
                }/>
                <br></br>
                <button type="button" onClick={event => {
                    getCount(eventDate);
                }} className="clear-btn">Enter</button>
                <button type="button" onClick={clearEvent} className="clear-btn">Clear</button>
            </div>
    )
}

export default CountdownWidget;